import type { Configuration } from '@ais-ui/api-spec/oceanio';
import { createContext, useContext } from 'react';
import type { Session } from './session';

export type AuthDialog = 'login' | 'registration' | 'registrationSuccess';

export interface AuthContextState {
  session?: Session;
  /** Shared by every OceanIO API client; carries the current token. */
  apiConfiguration: Configuration;
  login: (session: Session) => void;
  logout: () => void;
  openDialog: AuthDialog | null;
  showDialog: (dialog: AuthDialog) => void;
  closeDialog: () => void;
}

export const AuthContext = createContext<AuthContextState | undefined>(
  undefined,
);

export const useLogin = () => {
  const authContext = useContext(AuthContext);
  if (!authContext) {
    throw new Error('useLogin must be used within a LoginProvider');
  }
  return authContext;
};

export const useApiConfiguration = () => useLogin().apiConfiguration;
